import React, { useMemo, useState } from 'react';
import { createContext } from '@shared/utils/createContext';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { useKeycodeListener } from '@shared/utils/hooks/useKeycodeListener';

type HotelOfferDiagnosticsContextValue = Readonly<{
  showMargin: boolean;
  showProviderName: boolean;
}>;

const DEFAULT_CONTEXT_VALUE: HotelOfferDiagnosticsContextValue = {
  showMargin: false,
  showProviderName: false,
};

const [HotelOfferDiagnosticsContextProvider, useHotelOfferDiagnostics] = createContext<HotelOfferDiagnosticsContextValue>({
  name: 'HotelOfferDiagnostics',
  initialValue: DEFAULT_CONTEXT_VALUE,
  strict: false,
});

const MARGIN_HOTKEYS = ['M'] as const;
const PROVIDER_HOTKEYS = ['H'] as const;
const HOTKEY_OPTIONS = { ctrlKey: true, shiftKey: true };

export const HotelOfferDiagnosticsProvider = ({ children }: Readonly<{ children: React.ReactNode }>) => {
  const [showMargin, setShowMargin] = useState(false);
  const [showProviderName, setShowProviderName] = useState(false);

  const toggleMargin = useEventCallback(() => setShowMargin(prev => !prev));
  const toggleProviderName = useEventCallback(() => setShowProviderName(prev => !prev));

  useKeycodeListener(MARGIN_HOTKEYS, toggleMargin, HOTKEY_OPTIONS);
  useKeycodeListener(PROVIDER_HOTKEYS, toggleProviderName, HOTKEY_OPTIONS);

  const value = useMemo(() => ({ showMargin, showProviderName }), [showMargin, showProviderName]);

  return <HotelOfferDiagnosticsContextProvider value={value}>{children}</HotelOfferDiagnosticsContextProvider>;
};
export { useHotelOfferDiagnostics };
